import type { NavItem } from '@client/types';
import { SERVICE_HREF_DATA_KEY } from './account-scoped-href';

// Assets: SVG
import ddArrowSvg from '../assets/svgs/dd-arrow.svg';

export default function createLink({
  hasChildren = false,
  isExternalService,
  isSubscribed = true,
  purchaseUrl,
  text,
  url,
  urlAppend = null,
  appendUrlParams = false,
  isActive,
}: NavItem & { hasChildren?: boolean }) {
  const anchorElm = document.createElement('a');

  if (appendUrlParams && urlAppend) {
    // url_append arrives resolved and percent-encoded from the server (never
    // partial), so its values round-trip through URLSearchParams as single
    // params. document.baseURI is the base so a relative url resolves to the
    // same target it would when assigned directly (below).
    const mergedUrl = new URL(url, document.baseURI);
    new URLSearchParams(urlAppend).forEach((value, key) => {
      mergedUrl.searchParams.set(key, value);
    });
    anchorElm.setAttribute('href', mergedUrl.toString());
  } else {
    anchorElm.setAttribute('href', url);
  }
  anchorElm.dataset[SERVICE_HREF_DATA_KEY] =
    anchorElm.getAttribute('href') ?? '';
  if (isActive) anchorElm.classList.add('active');
  if (isExternalService) {
    anchorElm.setAttribute('target', '_blank');
    anchorElm.setAttribute('rel', 'noopener');
  }
  anchorElm.dataset.growthHubLink = undefined;

  anchorElm.innerHTML = `
    <button
      data-gh-service-name="${text}"
      data-gh-service-is-subscribed="${isSubscribed}"
      data-gh-service-buy-link="${purchaseUrl}"
    >${text}${
      hasChildren ? `<span class="dd-arrow">${ddArrowSvg}</span>` : ''
    }</button>
  `;

  return anchorElm;
}
